enum ValuesValidation {
  POSITIVE_VALUE  = 'S',
  YES_VALUE       = 'Y',
  NEGATIVE_VALUE  = 'N',
  POSITIVE_NUMBER = '1'
}

export class BooleanUtils {

  static isTrueValue(value?: string): boolean {
    return value === ValuesValidation.POSITIVE_VALUE || value === ValuesValidation.YES_VALUE;
  }

  static isPositiveValue(value?: boolean): string {
    return value ? ValuesValidation.POSITIVE_VALUE : ValuesValidation.NEGATIVE_VALUE
  }

  static numberIsPositiveValue(value?: string): string {
    return this.isPositiveValue(value === ValuesValidation.POSITIVE_NUMBER)
  }

  static isNotNull(value?: string | number): boolean {
    return value != null;
  }
}